// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect, type ReactNode } from 'react';

import { useEvolveGet, type Task, type TaskId } from '@evolvemep/api-ts';
import { Box, LoadingOverlay } from '@mantine/core';

import { isNil } from 'helpers/isNotNil';

type Props = {
  /** The task ID to load. */
  taskId: TaskId;
  /** The task, which is null when not yet loaded. */
  task: Task | null;
  onTaskLoaded: (task: Task) => void;
  children: (task: Task) => ReactNode;
};

export const TaskTimeTaskLoader = ({ taskId, task, onTaskLoaded, children }: Props) => {
  const { apiCall: getTaskApiCall, loading: loadingTask } = useEvolveGet(`shop/task/${taskId}`);

  useEffect(() => {
    /** Load the latest version of the task on mount (i.e. when the modal opens).
     *  This helps ensure time tracking is accurate. */
    void getTaskApiCall().then(onTaskLoaded);
  }, [getTaskApiCall, onTaskLoaded]);

  if (loadingTask || isNil(task)) {
    return (
      <Box pos="relative" mih={270}>
        <LoadingOverlay visible />
      </Box>
    );
  }

  return children(task);
};
